import React from "react";
//import Ads from "../../ad-config";
import { Bling as GPT } from "react-gpt";
GPT.enableSingleRequest();
export default class ROS_Top_336_280 extends React.Component {
  render() {
    let Ads = this.props.AdData;
    // console.log("ads ",Ads.adunitPath_rosTop300250)
    return (
      <div className= "ads_336_280">
    {(() => {
         if (Object.keys(this.props.AdData).length> 0 ) {
           return (
            <GPT
            adUnitPath={Ads.adunitPath_rosTop300250}   
            name={Ads.name_rosTop300250}
             slotSize={[336, 280]}
/>
           )
         } 
       })()}
     
   </div>
     
    );
  }
}
